{
	"sections": {
		"competition": "Competition",
		"participants": "Participants",
		"results": "Results",
		"setup": "Setup"
	},
	"items": {
		"dashboard": "Dashboard",
		"meets": "Meets",
		"allSports": "All sports",
		"medals": "Medal tally",
		"athletes": "Athletes",
		"athleteManager": "Athlete manager",
		"teams": "Teams & entries",
		"paraSupport": "Para support",
		"nocs": "NOCs",
		"officials": "Officials",
		"records": "Records",
		"reports": "Reports",
		"featuredVideo": "Featured video",
		"gmsSetup": "Sports & events in GMS"
	},
	"short": {
		"dashboard": "Home",
		"meets": "Meets",
		"medals": "Medals",
		"athletes": "Athletes",
		"athleteManager": "Fix",
		"teams": "Teams",
		"paraSupport": "Para",
		"nocs": "NOCs",
		"officials": "Officials",
		"records": "Records",
		"reports": "Reports",
		"featuredVideo": "Video",
		"gmsSetup": "Setup"
	},
	"crumbs": {
		"label": "Breadcrumb",
		"more": "Show the full path",
		"sport": "Sport",
		"meet": "Meet",
		"startList": "Start list",
		"standings": "Standings",
		"athlete": "Athlete",
		"entry": "Entry",
		"noc": "NOC"
	},
	"later": {
		"tag": "Later",
		"hint": "Coming later"
	},
	"sidebar": {
		"label": "Main navigation",
		"home": "Go to the dashboard",
		"brandTitle": "SEA Games 2027",
		"brandSubtitle": "Official venue results",
		"searchSport": "Search sport",
		"noSportMatches": "No sport matches “{{query}}”",
		"sportsLoading": "Loading sports…",
		"sportsError": "Couldn't load the sports.",
		"noSports": "No sports in this games yet.",
		"opensInNewTab": "Opens GMS in a new tab",
		"collapse": "Collapse sidebar",
		"expand": "Expand sidebar",
		"openMenu": "Open menu",
		"closeMenu": "Close menu"
	},
	"games": {
		"label": "Games",
		"current": "Current games: {{name}}",
		"switchTo": "Switch to {{name}}",
		"switchGames": "Switch games",
		"menuLabel": "Choose the games",
		"para": "Para",
		"loading": "Loading games…",
		"loadError": "Couldn't load the games."
	},
	"profile": {
		"menu": "Account menu for {{name}}",
		"activeRole": "Active role",
		"switchRole": "Switch role"
	}
}
